import { useMemo } from 'react';
import { CustomAttributesEntity } from 'src/graphql/entities/custom-attributes/custom-attributes-config/custom-attributes-config';
import {
  toSidePanelDescriptor,
  useCustomAttributesSidePanel,
} from 'src/graphql/entities/custom-attributes/side-panel-context';
import { SidePanelPropertyDescriptor } from 'src/graphql/entities/side-panel-personalization';
import { sortDefinitionsByGroup } from './group-custom-attributes';
import { useCanViewCustomAttributes } from './use-can-view-custom-attributes';
import { useNormalizedCustomAttributeDefinitions } from './use-normalized-custom-attribute-definitions';

/** A related entity's catalog for the panel entity's partner — card-rendered, each card reads its own values. */
export function useRelatedCustomAttributeDescriptors(entity: CustomAttributesEntity): {
  properties: SidePanelPropertyDescriptor[];
  loading: boolean;
} {
  const { partnerId } = useCustomAttributesSidePanel();
  const canView = useCanViewCustomAttributes();
  const { visibleDefinitions, groups, loading } = useNormalizedCustomAttributeDefinitions({
    partnerId,
    entity,
  });

  return useMemo(
    () => ({
      properties: canView
        ? sortDefinitionsByGroup(visibleDefinitions, groups).map(toSidePanelDescriptor)
        : [],
      loading: canView && loading,
    }),
    [canView, visibleDefinitions, groups, loading],
  );
}
